export const addOnCodes = {
  canada_sports_plus: 'sports-plus-ca',
  cricket: 'intl-sports-cricket',
  mgm_plus: 'epix',
  mlb: 'mlb',
  nbalp: 'nbalp',
  nfl_redzone: 'fubotv-basic-deportes-extra',
  showtime: 'fubotv-basic-showtime',
  starz: 'starz',
  fubo_sports_redzone: 'us-more_sprt_rzone_ao-1',
}
